import type { IconData } from '@stacksjs/iconify-core'

export const listFilter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M96 197.333h320v32H96zm72 101.334h176v32H168zM216 400h80v32h-80zM48 96h416v32H48z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default listFilter
